import { incYenOf, incOf } from '../lib/pricing';
export const retailHero = {
  title: '百貨店外商・高級小売向け 法人研修',
  titleEn: 'FOR DEPARTMENT STORES & LUXURY RETAIL',
  lead: '外商・高級小売向け研修は、お得意様対応と訪問の作法を執事の基準で磨き上げるプログラムです。',
};

export const retailTrustBadges = [
  {
    icon: 'ri-home-smile-line',
    text: '訪問の作法を執事の基準で体系化',
  },
  {
    icon: 'ri-store-2-line',
    text: '出張型で店舗バックヤード・会議室にて実施',
  },
  {
    icon: 'ri-user-star-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const retailPainPoints = [
  {
    icon: 'ri-user-location-line',
    text: 'お得意様のご自宅やご勤務先へ伺う際の作法を、体系立てて教えられていません。訪問のマナーは先輩の背中を見て覚える属人的な伝承に頼っており、担当者ごとに振る舞いの質に差が出ています。',
  },
  {
    icon: 'ri-emotion-unhappy-line',
    text: '商品知識は十分に備わっている一方で、所作・言葉遣い・身だしなみが商品の格に追いついていません。高額品を扱うからこそ、担当者自身の立ち居振る舞いが商品価値の一部としてお客様に映ります。',
  },
  {
    icon: 'ri-gift-2-line',
    text: '高額品の提示・受け渡し・お包みの美しさに個人差があります。外商では、商品を差し出す手元の所作そのものが「信頼の証」です。包み方ひとつでお客様に与える印象は大きく変わります。',
  },
  {
    icon: 'ri-user-heart-line',
    text: '次世代のお得意様——若い富裕層との関係づくりに苦戦しています。従来のご挨拶回りだけでは通用しない新しいお得意様層に対し、押し付けがましくない信頼構築の技術が求められています。',
  },
];

export const whyButlerWorks = [
  {
    icon: 'ri-home-smile-line',
    title: '主の私邸で仕える執事の作法は、訪問の作法の原型である',
    description:
      '執事は、主の自宅という最もプライベートな空間で仕えてきた職業です。玄関先でのご挨拶、室内での立ち居振る舞い、辞去のタイミング——これらはすべて外商担当者が日々直面する場面と直結しています。訪問の作法を、最も蓄積のある職業から学びます。',
  },
  {
    icon: 'ri-service-line',
    title: '「売る所作」ではなく「仕える所作」を訓練する',
    description:
      '「商品を売り込む」姿勢ではなく、「お客様にお仕えする」所作を実技で繰り返し訓練することで、押し付け感のない自然な提案姿勢が身につきます。外商のお得意様が最も評価するのは、商品知識以上に「この人なら任せられる」という安心感です。',
  },
  {
    icon: 'ri-hand-heart-line',
    title: '提示・受け渡し・包み——手元の所作を細部まで矯正する',
    description:
      '風呂敷の扱い、化粧箱の開け閉め、商品を両手で差し出す角度と高さ。お客様が無意識に注視する手元の所作を、実技で細部まで矯正します。手元が美しいだけで、商品の格は一段上がります。',
  },
];

export const recommendedPrograms = [
  {
    title: '半日プラン例',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    modules: 'M1（立ち居振る舞い）＋ M3（提示・受け渡し実技）※小売向けにアレンジ',
    description:
      '立ち居振る舞いの基本と、商品提示・受け渡しの手元所作に集中する短期プランです。売場の隙間時間を活用した導入研修としてご利用いただけます。',
  },
  {
    title: '1日プラン例',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    modules: 'M1 ＋ M2（VIP・富裕層対応の原則）＋ M3 ＋ M4（お断り・代替提案ロールプレイング）',
    description:
      '所作からVIP対応、お断りの伝え方まで、外商・高級小売の接遇基盤を1日で網羅する推奨プランです。閉店後の夜間開催にも対応します。',
    recommended: true,
  },
  {
    title: '複数店舗巡回プラン',
    duration: '1日（6時間）×店舗数',
    price: incYenOf('ct-single-fullday'),
    modules: '1店舗あたり1日。2店舗目以降は同一単価',
    description:
      '複数店舗を巡回して順次実施するプランです。店舗ごとの売場環境に合わせた演習内容に調整し、全店で統一された接遇品質を実現します。',
  },
];

export const retailScenarios = [
  {
    number: '01',
    title: 'お得意様宅への訪問',
    description:
      '玄関先でのご挨拶、風呂敷やケースから商品を取り出してお見せする所作、お包みしてのお渡し、辞去の引き際までを通しで演習します。和室での座礼や畳の上での商品提示といった場面も含み、お得意様の生活空間に即した振る舞いを磨きます。お届けの品をどのように扱い、どのタイミングで退出するか——すべての所作に意味があります。',
    imageSeq: 'retail-scenario-1',
  },
  {
    number: '02',
    title: 'VIPルーム・サロンでの接客',
    description:
      'ご来店からVIPルームへのご案内、お席へのエスコート、お茶出しの所作、商品提示の角度と距離感、お包みまでの一連の流れを実技で確認します。高額品の商談では、商談室の空気そのものがお客様の購買意欲に影響します。空間を統べる所作を体系化します。',
    imageSeq: 'retail-scenario-2',
  },
  {
    number: '03',
    title: 'ご要望に沿えない場面での対応',
    description:
      '在庫切れ・取り扱い外のご要望に対し、お断りと代替提案をどのように組み立てるかをロールプレイングします。「お役に立てない」という状況でも、お客様の尊厳を守り、次のご来店につなげる対応を訓練します。外商において、断り方の巧拙は信頼に直結します。',
    imageSeq: 'retail-scenario-3',
  },
];

export const retailTargetRoles = [
  '外商担当',
  'VIPルーム・サロン担当',
  '店長・売場責任者',
  '高級ブランド販売員',
  'ギフトサロン担当',
];

export const retailPricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '2日間パッケージ',
    duration: '2日間（各6時間）',
    price: incYenOf('ct-single-2day'),
    note: '全モジュール対応',
  },
  {
    name: '継続プログラム',
    duration: '月1回半日×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    note: '定着と改善を繰り返す長期設計',
  },
];

export const retailPricingConditions = {
  dispatch: '出張時の交通費は実費別途',
  capacity: '推奨12名まで。超過する場合は2班制等をご提案します。複数店舗からの合同参加も対応可能です。',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
  nightAvailable: '閉店後の夜間開催・複数店舗での巡回開催に対応します。',
};

export const retailFlowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description:
      '対象人数・課題・希望時期などをオンラインまたはお電話で伺います。事前に研修内容資料をお送りすることも可能です。なお、歳暮・中元などの催事繁忙期を避けた日程のご提案も承ります。',
  },
  {
    step: '03',
    title: 'プログラム提案・お見積り',
    description:
      'ヒアリング内容をもとに、貴社に最適な研修プログラムとお見積りをご提案します。事前に研修内容資料をお送りできますので、稟議のご準備にもご活用ください。概算お見積りのみのご依頼でも構いません。',
  },
  {
    step: '04',
    title: '実施',
    description:
      '出張または来校にて研修を実施します。出張型では貴社の店舗バックヤード・会議室を使用し、実際の売場動線で訓練することで研修翌日からの再現性が高まります。閉店後の夜間開催や、複数店舗を巡回する形での実施にも対応します。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const retailBusinessTypeOptions = [
  { value: '', label: '選択してください' },
  { value: 'department-store-gaitansho', label: '百貨店外商' },
  { value: 'department-store-floor', label: '百貨店売場' },
  { value: 'luxury-brand', label: '高級ブランド' },
  { value: 'specialty-store', label: '専門店' },
  { value: 'other', label: 'その他' },
];

export const retailFormatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const retailFaqs = [
  {
    question: '執事の資格が取れる研修ですか？',
    answer:
      'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  },
  {
    question: '閉店後の夜間に実施できますか？',
    answer:
      'はい、対応します。開始時刻と会場条件をヒアリング時にお知らせください。外商部門の皆様の勤務実態を踏まえ、柔軟に日程を設定します。',
  },
  {
    question: '一般的な販売ロールプレイング研修と何が違いますか？',
    answer:
      '販売トークではなく、訪問・提示・受け渡しといった「仕える所作」を実技で鍛える点が違いです。商品知識研修と併用いただく形を推奨しています。商談技法の研修を否定するものではなく、接遇の土台を補完する役割です。',
  },
  {
    question: '複数店舗をまとめて実施できますか？',
    answer:
      'はい。合同開催のほか、店舗を巡回する複数回開催もご提案できます。各店舗の売場環境や商材に合わせて演習内容を調整しますので、ヒアリング時に店舗数とご希望のスケジュール感をお聞かせください。',
  },
];

export const retailRelatedPages = [
  {
    title: 'ホテル・旅館',
    description: 'バトラーサービスの型を開業前に整える',
    href: '/corporate/hotel',
  },
  {
    title: '高級レジデンス',
    description: 'コンシェルジュ・フロントの接遇品質を統一',
    href: '/corporate/residence',
  },
  {
    title: '金融・プライベートバンク',
    description: '富裕層営業の所作と距離感を鍛える',
    href: '/corporate/finance',
  },
  {
    title: 'ラグジュアリー営業',
    description: '高級車・宝飾・不動産の商談体験を設計',
    href: '/corporate/luxury-sales',
  },
  {
    title: '医療・美容クリニック',
    description: '自由診療の接遇を院内に定着',
    href: '/corporate/clinic',
  },
  {
    title: '自動車・モビリティ',
    description: 'ブランド体験の接遇を高める',
    href: '/corporate/automotive',
  },
  {
    title: 'ハイヤー・送迎',
    description: '乗降の所作と車内の気配りを磨く',
    href: '/corporate/chauffeur',
  },
];